var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5341",
    "data-name": "Group 5341",
    transform: "translate(0.033 -0.384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4367",
    "data-name": "Group 4367",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    transform: "translate(-0.033 0.384)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-2",
    "data-name": "Oval",
    cx: 18.5,
    cy: 19,
    rx: 18.5,
    ry: 19,
    transform: "translate(2.967 2.384)",
    fill: "#ff3535"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1873",
    "data-name": "Path 1873",
    d: "M157.533,72.8a1.919,1.919,0,0,0-1.357.563L145.14,84.4a2.056,2.056,0,0,0-.487.819l-1.562,5.352a.915.915,0,0,0,.23.9.889.889,0,0,0,.64.256.874.874,0,0,0,.256-.026l5.352-1.562a2.057,2.057,0,0,0,.82-.487l11.036-11.036a1.916,1.916,0,0,0,0-2.714l-2.535-2.535a1.917,1.917,0,0,0-1.357-.564ZM149.7,87.806l-2.714-2.714,7.426-7.426,2.714,2.714Zm-3.61-1.1,2,2-2.817.819ZM160.2,77.256a.194.194,0,0,1-.026.1L158.4,79.1l-2.714-2.714,1.741-1.741a.154.154,0,0,1,.1-.026.194.194,0,0,1,.1.026l2.535,2.535c0,.026.026.051.026.077Z",
    transform: "translate(-129.99 -60.719)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.3ea76e81e049a8ea3402774ae5c43471.svg";
export { ForwardRef as ReactComponent };